import { http } from '@pendo/http';
import semver from 'semver';
import { environmentBucket } from '@/settings/environment.utils';
import moment from 'moment-timezone';
import capitalize from 'lodash/capitalize';
import cloneDeep from 'lodash/cloneDeep';

export function supportsJWTIfEnabled (version, isSecureSnippetEnabled) {
    if (isSecureSnippetEnabled) {
        return semver.satisfies(semver.coerce(version), '>=2.56.0');
    }

    return true;
}

export function supportsLightning (version) {
    return semver.satisfies(semver.coerce(version), '>=2.11.3');
}

export function formatLabel (version, timestamp, isLatest) {
    const releasedDate = `${moment(timestamp).format('MMM D, YYYY')}`;

    return [
        version.deprecated ? '!! ' : '',
        `Version ${version} `,
        `released ${releasedDate}`,
        isLatest ? ' (Latest Stable)' : '',
        version.deprecated ? ' (deprecated)' : '',
    ].join('');
}

export async function getAgentVersions () {
    const { data: agentVersions } = await http.get(`https://${environmentBucket(true)}/agent/releases/versions.json`, {
        withCredentials: false,
    });
    agentVersions.latest = cloneDeep(agentVersions[agentVersions.latest]);
    agentVersions.stable = cloneDeep(agentVersions[agentVersions.stable]);
    agentVersions.beta = cloneDeep(agentVersions[agentVersions.beta]);

    return agentVersions;
}

export function getEnvSettings ({ agent, config }) {
    const agentSupportsLightning = supportsLightning(agent.agentVersion);
    const { agentVersion, agentType } = agent;
    const agentReleaseDate = moment(agent.agentReleasedAt).format('MMM D, YYYY');
    const description = config.name;
    const agentPolicy = getAgentPolicy(config);

    return {
        agentSupportsLightning,
        agentVersion,
        agentType,
        agentReleaseDate,
        description,
        agentPolicy,
    };
}

export function getAgentPolicy ({ agentUpdatePolicy }) {
    if (agentUpdatePolicy === 'latest') {
        agentUpdatePolicy = 'stable'; // 'latest' is deprecated use 'stable' instead
    }

    return ['stable', 'beta'].includes(agentUpdatePolicy) ? agentUpdatePolicy : 'manual';
}

export async function fetchEnv ({ env = 'production', appId }) {
    const response = await http.get(`/api/s/_SID_/environment/${env}?appId=${appId}`);

    return response.data;
}

export async function patchEnv ({ appId, description, agentType, agentUpdatePolicy }) {
    return http.patch(`/api/s/_SID_/environment/${description}/config?appId=${appId}`, {
        agentType,
        agentUpdatePolicy,
        description: `${capitalize(description)} environment`,
    });
}

export async function checkStagingServer () {
    const response = await http.get('/api/s/_SID_/staging/status');

    return response.data.hasStagingServers;
}
